// Film Data for Ìfé - The Sequel

export const filmData = {
  title: "Ìfé",
  subtitle: "The Sequel",
  tagline: "A Pamela Adie Film",
  year: 2026,
  runtime: "117 minutes",
  genre: "Romantic Drama",
  country: "Nigeria",
  contactEmail: "ifemovie@gmail.com",
  instagram: "ife_thesequel",
  instagramUrl: "https://instagram.com/ife_thesequel",
  vimeoUrl: "https://youtu.be/E5ssP-MvBpM",
  youtubeVideoId: "E5ssP-MvBpM",
  
  gallery: [
    {
      url: "https://customer-assets.emergentagent.com/job_maroon-mustard/artifacts/weysgw60_Ife%20sequel%20still%2016.jpg",
      caption: "Film Still"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_maroon-mustard/artifacts/ifzgqd04_Ife%20sequel%20still%2023.jpg",
      caption: "Film Still"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_maroon-mustard/artifacts/pnxlhvwk_Ife%20sequel%20still%2039.jpg",
      caption: "Film Still"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_maroon-mustard/artifacts/l8rffoh3_Ife%20sequel%20still%2041.jpg",
      caption: "Film Still"
    }
  ],
  posterUrl: "https://customer-assets.emergentagent.com/job_2a31d3f1-ba66-4b34-8642-f544d725fdce/artifacts/p0qw8b1n_IFE%20SEQUEL%20MAIN%20POSTER_resized.jpg",
  pressKitUrl: "https://customer-assets.emergentagent.com/job_maroon-mustard/artifacts/vhvljo7f_EPK%20for%20Ife%28the%20sequel%29%20%281%29.pdf",
  
  logline: "When former lovers Ife and Adaora cross paths in Lagos after years apart, buried desires resurface, forcing them to choose between the lives they've built and a forbidden love that could cost them everything.",
  
  synopsis: "In a bustling Lagos where tradition and modernity collide, Ife and Adaora; two women whose love once burned brightly, meet again after years apart. Adaora has built a life of conformity, while Ife has learned to carve her own space of freedom. Their reunion stirs old desires and unresolved questions: Can they reclaim what was lost? And what must they risk to do so? Ìfé: The Sequel unfolds as a poignant exploration of love, choice, and identity in a society that refuses to see them. Both intimate and political, the film speaks to the universal longing for connection and the courage it takes to live authentically.",
  
  introduction: "Ìfé: The Sequel is a bold Nigerian love story that dares to center queer women in a society that denies their existence. Set in Lagos, the film captures the joy, tension, and courage of loving against the odds. Rooted in Nigerian culture yet universal in its themes of love, family, and freedom, it speaks to anyone who has ever fought to live and love authentically. With tenderness and unapologetic honesty, Ìfé: The Sequel challenges conformity and expands the global imagination of what African love stories can be.",
  
  directorsStatement: `Growing up in Nigeria, I rarely saw authentic queer love stories on screen, especially not ones that reflected the lives, struggles, and joys of LGBTQ+ people in Africa. Stories about us were often erased, misrepresented, or hidden behind coded language. Ìfé was born out of a deep desire to change that. I wanted to create a film that does not ask for permission to exist but boldly claims space for African queer love.

This story is deeply personal to me. Like Adaora, I was once married to a man. I know firsthand the pressures of societal expectations, the weight of doing what is "right" in the eyes of family and culture while silently rejecting who you truly are. It took immense courage to step out of that life, to come out to my family, and to choose myself. Unlike Adaora, I didn't have an Ìfé in my story, someone to remind me that love could be freeing. But I hope Ìfé serves as that voice for others.

At its heart, Ìfé, the sequel is a love story, simple, yet revolutionary in its context. Ife and Adaora's relationship challenges the notion that queerness is "un-African" and instead affirms that love, in all its forms, is universal. Their journey mirrors the choices so many LGBTQ+ people face in conservative societies: Do you live for others, or do you fight for your own happiness?

Filmmaking, for me, is not just about storytelling; it is about advocacy, representation, and resistance. In a country where LGBTQ+ rights are constantly under threat, Ìfé is more than just a film; it is an act of defiance, a mirror for those who have never seen themselves reflected, and a beacon of hope for those who dream of a world where love is free.

With Ìfé, I want others like me to know that happiness is worth pursuing and sacrificing for. It may not be easy, but it is possible, and it is worth it.`,
  
  director: {
    name: "Pamela Adie",
    role: "Director / Producer",
    bio: "Pamela Adie is a Nigerian filmmaker, producer, and LGBTQIA+ advocate committed to increasing the visibility of queer women in Nigeria through film. She is the creative force behind Under The Rainbow (Nigeria's first lesbian documentary), the groundbreaking short film Ìfé, and the limited web series Center Stage. Through her storytelling, she challenges societal norms, fosters inclusion, and sparks critical conversations about love, identity, and acceptance. Her films have screened at over 25 international festivals and received global media attention from CNN, BBC, and Reuters. In addition to filmmaking, Pamela is a recognized leader in social advocacy. She was selected for the prestigious Obama Foundation Leaders Africa Program and received the Young Alumni Achievement Award from the University of Wisconsin-Superior for her impact on media and activism. As the founder of The Equality Hub, she continues to push boundaries in African cinema, using storytelling to drive social change.",
    imageUrl: "https://customer-assets.emergentagent.com/job_maroon-mustard/artifacts/klgcjx94_705a56c2-2b5b-4806-a28e-816a2cf120d0.jpg"
  },
  
  screenwriter: {
    name: "Uyaiedu Ikpe-Etim",
    role: "Screenwriter",
    bio: "Uyaiedu Ikpe-Etim is a Nigerian director, screenwriter, and producer known for her humane portrayals of LGBTQ+ lives. In 2020, she made her directorial debut with Ìfé, Nigeria's first lesbian film told outside of stereotypes. The film challenged Nigeria's anti-LGBTQ laws and censorship, premiering internationally at festivals such as Vancouver's LGBT Film Festival and Leeds International Film Festival. A member of the LGBTQ+ community herself, Ikpe-Etim has been writing since age 17 and gained early experience with filmmaker Jeta Amata before pursuing a degree in radio, television, and film in Cyprus. Named to the BBC's 100 Women of the Year in 2020, Ikpe-Etim continues to focus her work on centering Black women, love, and agency in film."
  },
  
  cast: [
    {
      name: "Uzoamaka Aniunoh",
      role: "Ife",
      bio: "Uzoamaka Aniunoh is an actor, writer and filmmaker based in Lagos. She was the 2023 Berlinale Talent from Nigeria, participating in the Berlin International Film Festival Acting Studio. In 2021, she won the Kim Renders Outstanding Performance Award at the Kingston Reelout Film Festival for her work in Ìfé. In 2024, 'The Weekend', led by Uzoamaka, made its world premiere at the Tribeca Film Festival and BFI London Film Festival.",
      featured: true
    },
    {
      name: "Gbubemi Ejeye",
      role: "Adaora",
      bio: "Gbubemi Ejeye is a Nigerian actress making waves in Nollywood with standout performances in popular films and series. She has captivated audiences in projects like Farmer's Bride and Far From Home. Recently, she starred in The Other Side of the Bridge, which premiered at AFRIFF 2024, and Headless, the highly anticipated opening film of AFRIFF 2024.",
      featured: true
    },
    {
      name: "Ozzy Agu",
      role: "Dafe",
      bio: "Classically trained at the American Academy of Dramatic Arts, New York City, Ozzy Agu has been selected as a 2025 Berlinale Talent at the prestigious Berlin International Film Festival. Most recently, he starred in Over The Bridge, a Best Film nominee at the 2024 Africa Magic Viewers' Choice Awards.",
      featured: true
    },
    { name: "Adunolaoluwa Osinowo", role: "Bhewkiwe", featured: false },
    { name: "'Najite Dede", role: "Aunty Kainene", featured: false },
    { name: "Amara Nnanna", role: "Samirah", featured: false },
    { name: "Sonny McDon", role: "Prof. Ejiofor", featured: false },
    { name: "Grace Coker", role: "Prof. Edikan", featured: false },
    { name: "Binta Ayo Mogaji", role: "Adunni", featured: false },
    { name: "Halima Ganiyu", role: "Zazi", featured: false },
    { name: "Okudare Marytonette", role: "Ayomide", featured: false },
    { name: "Damilola Akin-Olasupo", role: "Soft", featured: false },
    { name: "Gbohunmi David", role: "Ugo", featured: false },
    { name: "Mena Sodje", role: "Dr. Bassey", featured: false }
  ],
  
  crew: [
    { name: "Pamela Adie", role: "Director / Producer" },
    { name: "Uyaiedu Ikpe-Etim", role: "Screenwriter" },
    { name: "Asurf Oluseyi", role: "DOP & Editor" },
    { name: "Zzinni Ekeh", role: "Production Manager" },
    { name: "Naomi Paul", role: "Costume Designer" },
    { name: "Bangie Artistry", role: "Hair & Make-up Designer" },
    { name: "Anwuli Roseline", role: "Sound Design & Composition" },
    { name: "Jago Sound", role: "Production Sound Recordist" },
    { name: "Amaka Chidioka", role: "First Assistant Director" },
    { name: "Temmie Ovwasa", role: "Music" }
  ],
  
  executiveProducers: [
    "The Equality Hub",
    "Pamela Adie",
    "Nkiru Emina",
    "Uju Anya",
    "Rev. Jide Macaulay",
    "Adetoye Mafe"
  ],
  
  productionCompany: {
    name: "The Equality Hub"
  },
  
  laurels: [
    {
      festival: "BFI Flare London LGBTQIA+ Film Festival",
      award: "Official Selection 2026",
      year: "2026",
      imageUrl: "https://customer-assets.emergentagent.com/job_maroon-mustard/artifacts/l9sz9bb1_BFI-Flare_2026-Laurels_OFFICIAL%20SELECTION%20POS.png"
    },
    {
      festival: "CinemaQueer International Film Festival",
      award: "Official Selection",
      year: "2026",
      imageUrl: "/laurels/cinemaqueer.png"
    },
    {
      festival: "Pink Screens Film Festival",
      award: "Official Selection Brussels 2026",
      year: "2026",
      imageUrl: "https://customer-assets-cm19k8pv.emergentagent.net/job_a321023f-ffc8-4062-b707-e88ac5375543/artifacts/078c63264cee2034_Laurels_Colors_2026.png"
    }
  ],
  
  screenings: [
    {
      festival: "BFI Flare London LGBTQIA+ Film Festival",
      strand: "Hearts",
      location: "BFI Southbank, London",
      date: "March 23, 2026",
      time: "8:40 PM",
      ticketUrl: "https://www.bfi.org.uk/flare"
    },
    {
      festival: "BFI Flare London LGBTQIA+ Film Festival",
      strand: "Hearts",
      location: "BFI Southbank, London",
      date: "March 24, 2026",
      time: "3:00 PM",
      ticketUrl: "https://www.bfi.org.uk/flare"
    },
    {
      festival: "CinemaQueer International Film Festival",
      strand: "",
      location: "Hartwig Kulturhus, Stockholm, Sweden",
      date: "October 3, 2026",
      time: "5:30 PM",
      ticketUrl: "https://cinemaqueer.se/portfolio_page/ife-the-sequel/"
    },
    {
      festival: "Pink Screens Film Festival",
      strand: "",
      location: "Cinema Adventure, Brussels",
      date: "November 6, 2026",
      time: "7:15 PM",
      ticketUrl: "https://pinkscreens.org/en/queer-o-rama/fiction/ife-sequel"
    }
  ],
  
  pressQuotes: []
};

export default filmData;
